"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.borderTypesEnum = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var borderTypesEnum;
(function (borderTypesEnum) {
    borderTypesEnum["LEFT"] = "left";
    borderTypesEnum["RIGHT"] = "right";
    borderTypesEnum["ALL"] = "all";
})(borderTypesEnum = exports.borderTypesEnum || (exports.borderTypesEnum = {}));
var BORDER_RADIUS = (_a = {},
    _a[borderTypesEnum.LEFT] = '0px 10px 10px 0px',
    _a[borderTypesEnum.RIGHT] = '10px 0px 0px 10px',
    _a[borderTypesEnum.ALL] = '50px',
    _a);
var VideoProgressBar = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 5px;\n  width: ", ";\n  background: rgba(255, 255, 255, 0.64);\n  margin: 12px 0;\n  border-radius: ", ";\n  transition: height 0.3s ease, margin 0.3s ease;\n  transition: background 0.3s ease, margin 0.3s ease;\n  cursor: pointer;\n\n  @keyframes fadeIn {\n    0% {\n      background-color: #ffa841;\n      width: 1%;\n    }\n    100% {\n      background-color: rgba(255, 255, 255, 0.64);\n    }\n  }\n\n  &.introduce {\n    animation: fadeIn 800ms ease-out;\n  }\n\n  &:hover {\n    height: 5px;\n  }\n"], ["\n  height: 5px;\n  width: ", ";\n  background: rgba(255, 255, 255, 0.64);\n  margin: 12px 0;\n  border-radius: ", ";\n  transition: height 0.3s ease, margin 0.3s ease;\n  transition: background 0.3s ease, margin 0.3s ease;\n  cursor: pointer;\n\n  @keyframes fadeIn {\n    0% {\n      background-color: #ffa841;\n      width: 1%;\n    }\n    100% {\n      background-color: rgba(255, 255, 255, 0.64);\n    }\n  }\n\n  &.introduce {\n    animation: fadeIn 800ms ease-out;\n  }\n\n  &:hover {\n    height: 5px;\n  }\n"])), function (props) { return props.barWidth; }, function (_a) {
    var radiusSide = _a.radiusSide;
    return BORDER_RADIUS[radiusSide];
});
exports.default = VideoProgressBar;
var templateObject_1;
